var _defs, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupervisorCaseload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 47.16 47.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#11ccea;}.cls-2{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 23.58,
    cy: 23.58,
    r: 23.58
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M249.81,217.42c.45.71.88,1.41,1.32,2.1a.22.22,0,0,0,.19.08.51.51,0,0,1,.54.27c.7,1.12,1.4,2.24,2.09,3.36a1.26,1.26,0,1,1-2.14,1.33l-2-3.27c-.22-.36-.22-.46,0-.8l-1.38-2.2a5,5,0,0,0-.62.24.3.3,0,0,0-.12.24c0,.82,0,1.63,0,2.44a3.07,3.07,0,0,1-3.17,3.17H228.69a3.07,3.07,0,0,1-3.14-3.15V198.36a3.06,3.06,0,0,1,3.12-3.13h15.87a3.06,3.06,0,0,1,3.14,3.14q0,4.19,0,8.35a.3.3,0,0,0,.24.34,6,6,0,0,1,2,10.23ZM238.3,196.34h-9.54a2,2,0,0,0-2.1,2.1v22.77a2,2,0,0,0,2,2.06h15.92a2,2,0,0,0,2-2V219a1.8,1.8,0,0,0,0-.22,6,6,0,0,1-4.57-1.47,6.07,6.07,0,0,1-.62-8.49,6,6,0,0,1,5.21-2.09v-8.1c0-.16,0-.32,0-.48a2,2,0,0,0-2.43-1.78v10.49l-2.91-3-2.92,3Zm7.56,11.46a5,5,0,1,0,5,4.84A5,5,0,0,0,245.86,207.8Z",
    transform: "translate(-215.56 -186.7)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M235.4,220.81h-6.1a.47.47,0,0,1-.39-.48.46.46,0,0,1,.44-.43h12.13a.44.44,0,0,1,.41.41.43.43,0,0,1-.34.48,1.08,1.08,0,0,1-.31,0Z",
    transform: "translate(-215.56 -186.7)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M234.67,216.7h5.11a1,1,0,0,1,.35.06.41.41,0,0,1,.23.44.41.41,0,0,1-.32.39,1.55,1.55,0,0,1-.31,0h-10.3a.47.47,0,0,1-.52-.48.46.46,0,0,1,.52-.44Z",
    transform: "translate(-215.56 -186.7)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M234.08,214.42h-4.5a1.38,1.38,0,0,1-.29,0,.44.44,0,0,1-.38-.46.45.45,0,0,1,.38-.43h9.64a.46.46,0,0,1,.37.45.44.44,0,0,1-.37.44h-4.85Z",
    transform: "translate(-215.56 -186.7)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M232.87,207h3.4a.46.46,0,0,1,.43.42.45.45,0,0,1-.36.45.89.89,0,0,1-.28,0H229.7c-.42,0-.66-.17-.65-.47s.22-.44.64-.44Z",
    transform: "translate(-215.56 -186.7)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M232.86,210.35h-3.18a1.22,1.22,0,0,1-.27,0,.44.44,0,0,1-.36-.43.41.41,0,0,1,.31-.43.9.9,0,0,1,.28,0h6.46a.82.82,0,0,1,.22,0,.47.47,0,0,1,.38.46.47.47,0,0,1-.45.43c-.17,0-.35,0-.53,0Z",
    transform: "translate(-215.56 -186.7)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M248.62,215.57H243.3a2.73,2.73,0,0,1,1.21-2.77,2.52,2.52,0,0,1,2.82-.06A2.77,2.77,0,0,1,248.62,215.57Z",
    transform: "translate(-215.56 -186.7)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M247.19,210.79a1.3,1.3,0,1,1-2.6,0,1.32,1.32,0,0,1,1.29-1.3A1.29,1.29,0,0,1,247.19,210.79Z",
    transform: "translate(-215.56 -186.7)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupervisorCaseload);
export default __webpack_public_path__ + "static/media/supervisor_caseload.bb68edbb8dcac70f60f23123626ffbe4.svg";
export { ForwardRef as ReactComponent };